<template>
  <div>
    <div class="container">
      <div class="row">
        <form class="mt-5 form-inline">
          <div class="filter_group">
            <div class="input_block">
              <p>C</p>

              <input class="form-control mb-2 mr-sm-2" type="date" id="ot-date-input"
                     v-model="startDate"
                     required>
            </div>
            <div class="input_block">
              <p>По</p>

              <input class="form-control mb-2 mr-sm-2" type="date" id="to-date-input"
                     v-model="endDate"
                     required>
            </div>
            <div class="input_block">
              <p>От</p>

              <input class="form-control mb-2 mr-sm-2" type="number" id="skip-date-input" v-model.number="skip">
            </div>
            <div class="input_block">
              <p>До</p>
              <input class="form-control mb-2 mr-sm-2" type="number" id="limit-date-input"
                     v-model.number="limit"
              >
            </div>
          </div>
          <div class="filter_group">
            <div class="input_block">
              <label class="typo__label">Дополнительные параметры фильтрации по сайтам</label>
              <multiselect v-model="value.sites" :options="siteSelectorOptions" :multiple="true" :close-on-select="false"
                           :clear-on-select="false" :preserve-search="true" placeholder="Выбрать"
                           :preselect-first="false" label="value" track-by="value" :show-labels="false">
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{ props.option.value }}</span>
                  </div>
                </template>
              </multiselect>

            </div>
            <div class="input_block">
              <label class="typo__label">Дополнительные параметры фильтрации по городам</label>
              <multiselect v-model="value.cities" :options="citySelectorOptions" :multiple="true" :close-on-select="false"
                           :clear-on-select="false" :preserve-search="true" placeholder="Выбрать"
                           :preselect-first="false" label="value" track-by="value" :show-labels="false">
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{ props.option.value }}</span>
                  </div>
                </template>
              </multiselect>

            </div>
            <div class="input_block" v-if="isAvailable(['admin', 'welder'])">
              <label class="typo__label">Дополнительные параметры фильтрации по партнерам</label>
              <multiselect v-model="value.partners" :options="partnerSelectorOptions" :multiple="true" :close-on-select="false"
                           :clear-on-select="false" :preserve-search="true" placeholder="Выбрать"
                           :preselect-first="false" label="value" track-by="value" :show-labels="false">
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{ props.option.value }}</span>
                  </div>
                </template>
              </multiselect>

            </div>
          </div>
          <div class="btn_group">
            <button type="button" class="btn btn-success btn_filter" @click="getTableData">
              <i class="fas fa-filter"></i>
              Фильтровать
            </button>
          </div>
        </form>

      </div>
    </div>

    <div class="table-optional-actions">
      <button @click="activePopups.createLid = true" type="button" class="btn btn-success">Добавить лид вручную</button>
    </div>

    <vue-table
      v-if="isAvailable(['admin'])"
      :data_table="DATATABLE"
    />
	  <moderator-vue-table
      v-else-if="isAvailable(['moderator'])"
      :data_table="DATATABLE"
    />
    <customer-vue-table
      v-else-if="isAvailable(['customer'])"
      :data_table="DATATABLE"
    />
    <vue-table
      v-else-if="isAvailable(['welder'])"
      :data_table="DATATABLE"
    />

    <!--    <br>-->
    <!--    <revogrid-table :data_table="DATATABLE"/>-->

    <create-lid-modal v-if="activePopups.createLid" @close="activePopups.createLid = false"/>
  </div>

</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import vueTable from '../components/table/vue-table'
import moderatorVueTable from '../components/table/moderator-vue-table'
import customerVueTable from '../components/table/customer-vue-table'
import revogridTable from '../components/table/revogrid-table'
import createLidModal from '@/components/modal/createLidModal'
import Multiselect from 'vue-multiselect'
// import api from "../services/api.js"

export default {
  name: "Table",
  // eslint-disable-next-line vue/no-unused-components
  components: {
    'vue-table': vueTable,
    // eslint-disable-next-line vue/no-unused-components
    'revogrid-table': revogridTable,
    'multiselect': Multiselect,
    'customer-vue-table': customerVueTable,
	  'moderator-vue-table': moderatorVueTable,
    createLidModal,
  },

  data: () => {
    return {
      cities: [],
      partners: [],
      sites: [],
      value: {
        sites: [],
        partners: [],
        cities: []
      },
      options: [],
      dataJson: {
        action: 'dateAge',
        optional: {
          start: '',
          finish: ''
        },
        order_by: ['-date'],
        params: Object()
      },
      startDate: '',
      endDate: new Date().toISOString().slice(0, 10),
      skip: 0,
      limit: 100,

      checkNewTableDateDelay: 30000,
      isActiveCheckDate: false,

      activePopups: {
        createLid: false,
      },
      lastUpdateTable: null,
      stopUpdateTable: false,
    }
  },

  computed: {
    ...mapGetters([
      'DATATABLE',
      'editDataRow',
      'meRoles',
      'getUserPartners',
      'Tow',
      'canUpdateTable',

      'citySelectorOptions',
      'siteSelectorOptions',
      'partnerSelectorOptions',
    ])
  },

  async created() {
    this.loadSelectorOptions();

    this.startDate = localStorage.getItem('startDate')
    this.endDate = new Date().toISOString().slice(0, 10)
    this.skip = localStorage.getItem('skip') || 0
    this.limit = localStorage.getItem('limit') || 100
    this.dataJson.optional.start = this.startDate
    this.dataJson.optional.finish = this.endDate
    if (!this.isAvailable(['admin', 'moderator']))this.dataJson.params.partner_id = this.getUserPartners
	  this.getTowsData()
    await this.getTableData()

    this.setEditDataRow()

  },

  mounted () {
    this.stopUpdateTable = false;
    this.checkNewTableDateLoop();
  },

  beforeDestroy () {
    this.stopUpdateTable = true;
  },

  methods: {
    ...mapActions([
      'POST_TABLE_FROM_API',
      'updateTableData',
      'setEditDataRow',
      'getTows',

      'loadSiteSelectorsInfo',
      'loadCitySelectorsInfo',
      'loadPartnerSelectorsInfo',
    ]),

    async getTowsData() {
          await this.getTows()
    },

    async getTableData() {

      this.POST_TABLE_FROM_API({
        dataJson: this.dataJson,
        skip: this.skip,
        limit: this.limit
      })
      .then(() => {
        this.lastUpdateTable = new Date(Date.now() + this.$tzoffset).toISOString().slice(0, 19);
      })
      .catch(() => {});
    },

    loadSelectorOptions () {
      this.loadSiteSelectorsInfo();
      this.loadCitySelectorsInfo();

      if (!this.isAvailable(['customer'])) {
        this.loadPartnerSelectorsInfo();
      }
    },

    isAvailable(roles) {
      return this.meRoles.map(item => roles.includes(item)).includes(true)
    },

    async checkNewTableDateLoop () {

      if (this.stopUpdateTable) {
        return;
      }

      this.isActiveCheckDate = true;

      if (!this.canUpdateTable) {
        this.isActiveCheckDate = false;
        return;
      }

      setTimeout(() => {

        if (this.canUpdateTable && new Date().toISOString().slice(0, 10) === this.endDate) {
          this.updateTable();
        }

        this.checkNewTableDateLoop();

      }, this.checkNewTableDateDelay);

    },

    async updateTable () {

      const curDate = new Date(Date.now() + this.$tzoffset).toISOString().slice(0, 19);
      const dataJson = JSON.parse(JSON.stringify(this.dataJson));

      dataJson.optional.start = this.lastUpdateTable ? this.lastUpdateTable : curDate;
      dataJson.optional.finish = curDate;

      this.updateTableData({
        dataJson: dataJson,
        skip: 0,
        limit: 100,
      })
      .then(() => {
        this.lastUpdateTable = curDate;
      })
      .catch(() => {});
    }
  },


  watch: {
    value: {
      handler(val) {
        this.dataJson.params = Object()
        val.cities.map(item => {
          if (this.dataJson.params[item.key]) {
            this.dataJson.params[item.key].push(item.value)
          } else {
            this.dataJson.params[item.key] = [item.value]
          }
        })

        val.partners.map(item => {
          if (this.dataJson.params[item.key]) {
            this.dataJson.params[item.key].push(item.value)
          } else {
            this.dataJson.params[item.key] = [item.value]
          }
        })

        val.sites.map(item => {
          if (this.dataJson.params[item.key]) {
            this.dataJson.params[item.key].push(item.value)
          } else {
            this.dataJson.params[item.key] = [item.value]
          }
        })
      },
      deep: true
    },

    canUpdateTable (val) {
      if (val && !this.isActiveCheckDate) {
        this.checkNewTableDateLoop();
      }
    },

    startDate: function (newVal) {
      this.dataJson.optional.start = newVal
      localStorage.setItem('startDate', newVal)
    },
    endDate: function (newVal) {
      this.dataJson.optional.finish = newVal
      localStorage.setItem('endDate', newVal)
    },
    skip: function (newVal) {
      this.limit = Number(newVal) + 100
      localStorage.setItem('skip', newVal)
    },
    limit: function (newVal) {
      localStorage.setItem('limit', newVal)
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

.table-optional-actions {
  padding: 20px 32px;
  padding-bottom: 0;
}

.filter_group {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
}

.input_block {
  margin-right: 10px;
}

.input_block p {
  margin-bottom: 3px;
}

.input_block label {
  color: #222;
}

.btn_group {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn_filter {
  margin: 20px auto;
  width: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn_filter i {
  margin-right: 3px;
  color: rgb(240, 240, 240);
}
</style>
